import { ISelfRegistrationForm } from 'components/SelfRegistration/types/dtos';
import { CompanyType } from 'components/SelfRegistration/types/enums';
import { readSessionItem, writeSessionItem } from 'utils/session-storage';

/**
 * Шаг регистрации переживает перезагрузку страницы: иначе после F5
 * пропадёт и заполненная форма, и поле кода, и таймеры,
 * хотя блокировки на бэкенде продолжают действовать.
 *
 * sessionStorage, а не localStorage: данные живут только пока открыта вкладка.
 * Код из SMS не сохраняется.
 */
const STORAGE_KEY = 'self-registration:step';

/** Ключи отсчётов для usePersistedCountdown */
export const COUNTDOWN_KEYS = {
  resendCode: 'self-registration:resend-code',
  codeLock: 'self-registration:code-lock',
  resendEmail: 'self-registration:resend-email',
};

export type PersistedStep = {
  values: Omit<ISelfRegistrationForm, 'code'>;
  codeSent: boolean;
  registeredEmail: string | null;
};

export const emptyStep: PersistedStep = {
  values: {
    companyType: CompanyType.Individual,
    name: '',
    contactPerson: '',
    email: '',
    phone: '',
  },
  codeSent: false,
  registeredEmail: null,
};

export const readStep = (): PersistedStep => {
  const saved = readSessionItem<Partial<PersistedStep> | null>(STORAGE_KEY, null);
  if (!saved) return emptyStep;

  return {
    values: { ...emptyStep.values, ...saved.values },
    codeSent: !!saved.codeSent,
    registeredEmail: saved.registeredEmail || null,
  };
};

export const writeStep = (step: PersistedStep) => writeSessionItem(STORAGE_KEY, step);
